<template>
    <div class="container">
        <div class="title">
            {{ title }}
        </div>
        <div class="slot">
            <slot></slot>
        </div>  
    </div>
</template>

<script>
export default {
    name: "AdditionalInfo",
    props: ['title']
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: auto;
  float: left;
  padding: 1rem 1.25rem;
  background: white;
  max-height: 400px;
  border-radius: 8px;
  box-shadow: 0px 0px 6px rgba($color: #000000, $alpha: 0.08);
  overflow-y: overlay;
  text-align: left;

  .title {
    float: left;
    width: 100%;
    font-size: 14px !important;
    color: #7E939C;
    font-weight: normal;
  }

  .slot {
    float: left;
    width: 100%;
    max-width: 100%;
    height: auto;
    margin-top: 8px;
  }

  
}
</style>